<template>
    <div class="min-h-screen flex flex-col sm:justify-center items-center pt-6 sm:pt-0 bg-gray-800">
        <img :src=image id="screen-image">
    </div>
</template>

<script>

export default {
    name: 'Screen',
    props: {
        image: String,
    },
}
</script>
